<template>
  <div>
    <v-row class="mx-auto" align="start">
      <v-col :cols="!functionDownloadArquivoModelo ? '12' : $vuetify.breakpoint.xs ? '10' : '8'">
        <validation-provider v-slot="{ errors }" :rules="required ? 'required' : undefined">
          <v-file-input
            v-model="arquivo"
            :label="fileInputLabel"
            placeholder="Selecione um arquivo CSV"
            outlined
            accept=".csv, .zip"
            :show-size="!fakeFileFound"
            truncate-length="30"
            :loading="uploadInProgress"
            loader-height="4"
            clearable
            :success="arquivoId && arquivo ? true : false"
            :error-messages="errors"
            @change="uploadNewFile()"
          />
        </validation-provider>
      </v-col>
      <v-col v-if="functionDownloadArquivoModelo" :cols="$vuetify.breakpoint.xs ? '2' : '4'" style="overflow: hidden">
        <v-tooltip bottom :disabled="!$vuetify.breakpoint.xs">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :outlined="!$vuetify.breakpoint.xs"
              :icon="$vuetify.breakpoint.xs"
              :loading="loadingArquivoModelo"
              small
              class="btn-arquivo-modelo-gma"
              block
              v-bind="attrs"
              @click="functionDownloadArquivoModelo()"
              v-on="on"
            >
              {{ $vuetify.breakpoint.xs ? '' : 'Baixar Arquivo Modelo' }}
              <v-icon :right="!$vuetify.breakpoint.xs" color="primary">mdi-download</v-icon>
            </v-btn>
          </template>
          <span>Clique Aqui Para Baixar o Arquivo Modelo</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <parametros-arquivo-csv :delimitador.sync="delimitador" :involucro.sync="involucro" :escape.sync="escape" />
    <v-row align="center" class="mx-auto">
      <v-col cols="12">
        <v-expansion-panels v-model="panels" accordion>
          <v-expansion-panel>
            <v-expansion-panel-header style="font-weight: 300; font-size: 15px">Editar Mapeamento</v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(value, coluna) in mapeamentoFinal" :key="coluna">
                      <td>
                        <strong class="d-inline-flex">
                          {{ coluna }}
                          <v-icon
                            v-if="[...camposObrigatorios].includes(coluna) && required"
                            size="9"
                            class="mb-1 pl-1"
                            color="error"
                          >
                            mdi-asterisk
                          </v-icon>
                        </strong>
                      </td>
                      <td style="max-width: 125px">
                        <validation-provider
                          v-slot="{ errors }"
                          :rules="{
                            required_if: [...camposObrigatorios].includes(coluna) && required,
                            uniqueMapeamento: valoresMapeados
                          }"
                        >
                          <v-autocomplete
                            v-model="mapeamentoFinal[coluna]"
                            eager
                            dense
                            :items="header"
                            clearable
                            no-data-text="Nenhum campo disponível."
                            :hide-details="errors.length ? false : true"
                            :error="[...camposObrigatorios].includes(coluna) && !mapeamentoFinal[coluna]"
                            :error-messages="errors"
                          />
                        </validation-provider>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService.js';
  import ConfiguracoesService from '@/services/ConfiguracoesService.js';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue')
    },

    props: {
      camposMapeamento: {
        type: Object,
        required: true
      },
      camposObrigatorios: {
        type: Array,
        default: () => []
      },
      required: {
        type: Boolean,
        default: true
      },
      uniqueFields: {
        type: Boolean,
        default: true
      },
      preloadItems: {
        type: Boolean,
        required: true
      },
      fileInputLabel: {
        type: String,
        required: false,
        default: 'Arquivo CSV'
      },
      functionDownloadArquivoModelo: {
        type: Function,
        required: false
      },
      loadingArquivoModelo: {
        type: Boolean,
        required: false
      }
    },

    emits: ['preLoadingItemsReleased', 'clearActionTriggered', 'uploadedFile', 'change'],

    data() {
      return {
        valoresMapeados: [],
        delimitador: ';',
        involucro: '"',
        escape: '"',
        panels: undefined,
        header: [],
        uploadInProgress: false,
        arquivo: undefined,
        arquivoId: '',
        fakeFileFound: false,
        mapeamentoFinal: {} /* Ira guardar as informações do mapeamento de acordo com oque o usuário selecionou */
      };
    },

    computed: {
      csvProperties() {
        return `${this.arquivoId}|${this.delimitador}|${this.involucro}|${this.escape}`;
      }
    },

    mounted() {
      this.mapeamentoFinal = this.camposMapeamento;
      if (!this.$route.params.id) this.getParamsArquivoCsv();

      if (this.preloadItems) this.$emit('preLoadingItemsReleased', true);
    },

    methods: {
      getParamsArquivoCsv() {
        ConfiguracoesService.getCsvCamposPadroes()
          .then((response) => {
            this.delimitador = response.data.campos.delimitador.valor;
            this.involucro = response.data.campos.involucro.valor;
            this.escape = response.data.campos.escape.valor;
          })
          .catch((err) => {
            console.error('Erro ao recuperar campos padrões do arquivo csv: ', err);
            this.$toast.error('Erro ao recuperar campos padrões do arquivo csv.', '', { position: 'topRight' });
          });
      },

      uploadNewFile() {
        if (!this.arquivo) {
          this.$emit('clearActionTriggered', true);
          return;
        }

        this.arquivoId = '';
        this.uploadInProgress = true;

        let formDataWithFile = new FormData();
        formDataWithFile.append('file', this.arquivo);

        ArquivosService.uploadFile(formDataWithFile)
          .then((response) => {
            this.arquivoId = response.data.arquivoId;
            this.fakeFileFound = false;
            this.getHeaderArquivo(response.data.arquivoId);
            this.panels = 0;
          })
          .catch((error) => {
            console.error(error);

            if (error?.data?.cod_erro == 10000) {
              let msg = 'Há mais de um arquido dentro do ZIP.<br>Adicione apenas um arquivo CSV.';
              this.$toast.error(msg, '', { position: 'topRight', timeout: 8000 });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
            }

            this.arquivo = undefined;
          })
          .finally(() => {
            this.uploadInProgress = false;
          });
      },

      getHeaderArquivo(id, autoPreencherMapeamento = true) {
        let infoArquivo = { id: id, delimitador: this.delimitador, involucro: this.involucro, escape: this.escape };

        ArquivosService.getHeaderArquivo(infoArquivo)
          .then((response) => {
            this.header = response.data.header;

            if (autoPreencherMapeamento) {
              this.mapeamentoFinal = this.camposMapeamento;
              Object.keys(this.mapeamentoFinal).forEach((key) => {
                this.mapeamentoFinal[key] = this.header.indexOf(key) !== -1 ? key : '';
              });
            }

            this.$emit('uploadedFile', infoArquivo);
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao obter cabeçalho do arquivo CSV.', '', { position: 'topRight' });
          });
      },

      exportMapeamento() {
        return JSON.stringify(this.mapeamentoFinal);
      },

      clearComponentData(mapeamento = {}) {
        this.panels = undefined;
        this.header = [];
        this.uploadInProgress = false;
        this.arquivo = undefined;
        this.arquivoId = '';
        this.fakeFileFound = false;
        this.mapeamentoFinal = mapeamento;
      },

      setFakeFileForValidation() {
        ArquivosService.getNameArquivoById(this.arquivoId)
          .then((response) => {
            this.arquivo = new File([''], response.data.nome, { type: 'text/csv' });
            this.fakeFileFound = true;
            this.getHeaderArquivo(this.arquivoId, false);
          })
          .catch((err) => {
            console.error('Erro ao recuperar arquivo csv: ', err);
            this.$toast.error('Erro ao recuperar arquivo csv.', '', { position: 'topRight' });
          });
      },

      fillFieldsCsv(id, delimitador, involucro, escape, mapeamento) {
        this.arquivoId = id;
        this.delimitador = delimitador;
        this.involucro = involucro;
        this.escape = escape;
        this.mapeamentoFinal = mapeamento;
        this.setFakeFileForValidation();
      },

      emitEventChange() {
        let infoArquivo = this.arquivoId
          ? {
              id: this.arquivoId,
              delimitador: this.delimitador,
              involucro: this.involucro,
              escape: this.escape,
              mapeamento: this.removeCamposNaoObrigatoriosNaoMapeados(this.mapeamentoFinal)
            }
          : { id: null, delimitador: null, involucro: null, escape: null, mapeamento: this.camposMapeamento };

        this.$emit('change', infoArquivo);
      },

      removeCamposNaoObrigatoriosNaoMapeados(mapeamento) {
        /* Percorre todos colunas do objeto de mapeamentos e caso encontrar uma coluna não obrigatoria que não esteja mapeada, irá setar como undefined para evitar erros de mapeamento de colunas vazias */
        Object.keys(mapeamento).forEach((coluna) => {
          if (mapeamento[coluna] === '' && ![...this.camposObrigatorios].includes(coluna)) {
            mapeamento[coluna] = undefined;
          }
        });
        return mapeamento;
      }
    },

    watch: {
      csvProperties() {
        this.emitEventChange();
      },

      mapeamentoFinal: {
        handler() {
          if (!this.uniqueFields) return;

          this.valoresMapeados = [];
          Object.keys(this.mapeamentoFinal).forEach((key) => {
            if (this.mapeamentoFinal[key]) this.valoresMapeados.push(this.mapeamentoFinal[key]);
          });
          this.$forceUpdate();

          this.emitEventChange();
        },
        deep: true
      }
    }
  };
</script>

<style>
  .btn-arquivo-modelo-gma {
    min-height: 56px !important;
    border-color: rgba(0, 0, 0, 0.38) !important;
    font-family: 'Gotham Rounded' !important;
  }
</style>